export default __webpack_public_path__ + "static/media/image-2.92bf6f74.png";